export default __webpack_public_path__ + "static/media/doctors-walking.3eaace9d.png";